<template>
  <cs-view single-view>
    <template v-slot:content>
      <slot-indicator slot-name="Single View Page Content" width="100%" height="100%">
        <template v-slot:content>
          <v-container>
            <v-row>
              <v-col v-if="engineeringMode">
                <v-row class="ma-3">
                  <cs-button
                    width="100%"
                    @click="onGetToken"
                    :loading="tokenLoading"
                    label="Get Token"
                  />
                </v-row>
                <v-row class="ma-3">
                  <cs-button
                    width="100%"
                    @click="onGetUser"
                    :loading="userLoading"
                    label="Get User"
                  />
                </v-row>
              </v-col>
              <v-col v-if="engineeringMode">
                <v-row class="ma-3">
                  <cs-button
                    width="100%"
                    @click="onLogout"
                    :loading="logoutLoading"
                    label="Logout Federated"
                  />
                </v-row>
              </v-col>

              <v-col>
                <v-card>
                  <div class="justify-center pt-2">Home Page</div>
                  <v-row class="ml-3 mb-2">
                    <a :href="`${geminiUrl}`">Gemini</a>
                  </v-row>
                  <v-row class="ml-3 mb-2">
                    <a :href="`${apolloUrl}`">Apollo</a>
                  </v-row>
                  <v-row class="ml-3 mb-2">
                    <a :href="`${artemisUrl}`">Artemis</a>
                  </v-row>
                </v-card>

                <v-card>
                  <div class="justify-center pt-2">Login Page</div>
                  <v-row class="ml-3 mb-2">
                    <a :href="`${geminiUrl}/login`">Gemini</a>
                  </v-row>
                  <v-row class="ml-3 mb-2">
                    <a :href="`${apolloUrl}/login`">Apollo</a>
                  </v-row>
                  <v-row class="ml-3 mb-2">
                    <a :href="`${artemisUrl}/login`">Artemis</a>
                  </v-row>
                </v-card>

                <v-card>
                  <div class="justify-center pt-2">Wide Navigation Page</div>
                  <v-row class="ml-3 mb-2">
                    <a :href="`${geminiUrl}/wide-nav`">Gemini</a>
                  </v-row>
                  <v-row class="ml-3 mb-2">
                    <a :href="`${apolloUrl}/wide-nav`">Apollo</a>
                  </v-row>
                  <v-row class="ml-3 mb-2">
                    <a :href="`${artemisUrl}/wide-nav`">Artemis</a>
                  </v-row>
                </v-card>
              </v-col>
              <v-col>
                <v-row class="ma-3">
                  <cs-button width="100%" @click="onSetLoading" label="Set Loading" />
                </v-row>
                <v-row class="ma-3">
                  <cs-button width="100%" @click="onClearLoading" label="Clear Loading" />
                </v-row>
              </v-col>
              <v-col>
                <v-card outlined>
                  <v-card-title> Deprecating... </v-card-title>
                  <v-row class="ma-3">
                    <cs-button
                      width="100%"
                      large
                      @click="fullscreenDialog = true"
                      label="Open Fullscreen Dialog"
                    />
                  </v-row>
                  <v-row class="ma-3">
                    <cs-button
                      width="100%"
                      @click="textTitleDialog = true"
                      label="Open Text Title Dialog"
                    />
                  </v-row>
                  <v-row class="ma-3">
                    <cs-button
                      width="100%"
                      small
                      @click="headerDialog = true"
                      label="Open Header Dialog"
                    />
                  </v-row>
                </v-card>
                <v-row class="ma-3">
                  <form-dialogs-test> </form-dialogs-test>
                </v-row>
              </v-col>
              <v-col>
                <v-row class="ma-3">
                  <cs-button width="100%" @click="onShowErrorAlert" label="Show Error Alert" />
                </v-row>
                <v-row class="ma-3">
                  <cs-button width="100%" @click="onShowSuccessAlert" label="Show Success Alert" />
                </v-row>
                <v-row class="ma-3">
                  <cs-button width="100%" @click="onShowInfoAlert" label="Show Info Alert" />
                </v-row>
                <v-row class="ma-3">
                  <cs-button width="100%" @click="onShowWarningAlert" label="Show Warning Alert" />
                </v-row>
                <v-row class="ma-3">
                  <cs-button
                    width="100%"
                    @click="onShowErrorAlertWithHrefAndFunc"
                    label="Show Clickable Error Alert (1 href & 1 func)"
                  />
                </v-row>
                <v-row class="ma-3">
                  <cs-button
                    width="100%"
                    @click="onShowSuccessAlertWithHref"
                    label="Show Clickable Success Alert (1 href)"
                  />
                </v-row>
                <v-row class="ma-3">
                  <cs-button
                    width="100%"
                    @click="onShowInfoAlertWithFunc"
                    label="Show Clickable Info Alert (1 func)"
                  />
                </v-row>
                <v-row class="ma-3">
                  <cs-button
                    width="100%"
                    @click="onShowWarningAlertWithHrefAndFunc"
                    label="Show Clickable Warning Alert (1 href & 1 func)"
                  />
                </v-row>
                <v-row class="ma-3">
                  <cs-button width="100%" @click="onClearAlert" label="Clear Alert" />
                </v-row>
                <v-row class="ma-3">
                  <export-docx />
                </v-row>
              </v-col>
              <v-col v-if="engineeringMode">
                <v-row class="ma-3">
                  <v-card v-if="!!tokenText">
                    <v-card-title> Token: </v-card-title>
                    <v-card-text class="token">
                      <div @click.stop.prevent="copyText" class="icon-btn">
                        <v-icon small> content_copy </v-icon>
                      </div>
                      <pre class="text-wrap">
                      {{ tokenText }}
                      </pre>
                      <input type="hidden" id="token-text" :value="tokenText" />
                    </v-card-text>
                  </v-card>
                </v-row>
                <v-row class="ma-3">
                  <v-card v-if="!!decodedTokenText">
                    <v-card-title>Decoded Token:</v-card-title>
                    <v-card-text class="code">
                      <pre>{{ decodedTokenText }}</pre>
                    </v-card-text>
                  </v-card>
                </v-row>
                <v-row class="ma-3">
                  <v-card v-if="!!userText">
                    <v-card-title>User:</v-card-title>
                    <v-card-text class="code">
                      <pre>{{ userText }}</pre>
                    </v-card-text>
                  </v-card>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </template>
      </slot-indicator>
      <cs-dialog
        v-model="fullscreenDialog"
        fullscreen
        transition="dialog-bottom-transition"
        scrollable
      >
        <template v-slot:fullscreen-dialog-header>
          <v-btn icon dark @click="fullscreenDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Settings</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn width="100%" dark text @click="fullscreenDialog = false"> Save </v-btn>
          </v-toolbar-items>
        </template>
        <template v-slot:fullscreen-dialog-body>
          <v-list three-line subheader>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>List item Title 1</v-list-item-title>
                <v-list-item-subtitle> List item Subtitle 1 </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>List item Title 2</v-list-item-title>
                <v-list-item-subtitle> List item Subtitle 2 </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list three-line subheader>
            <v-subheader>Checkbox Demo</v-subheader>
            <v-list-item>
              <v-list-item-action>
                <v-checkbox v-model="checkbox1"></v-checkbox>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Checkbox 1</v-list-item-title>
                <v-list-item-subtitle> Checkbox 1 description </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-action>
                <v-checkbox v-model="checkbox2"></v-checkbox>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Checkbox 2</v-list-item-title>
                <v-list-item-subtitle> Checkbox 2 description </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-action>
                <v-checkbox v-model="checkbox3"></v-checkbox>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Checkbox 3</v-list-item-title>
                <v-list-item-subtitle> Checkbox 3 description </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-divider></v-divider>
          <v-subheader>Show alerts</v-subheader>
          <v-list-item>
            <v-row>
              <v-col>
                <v-btn width="100%" @click="onShowErrorDialogAlert">Show Error Alert</v-btn>
              </v-col>
              <v-col>
                <v-btn width="100%" @click="onShowSuccessDialogAlert">Show Success Alert</v-btn>
              </v-col>
              <v-col>
                <v-btn width="100%" @click="onShowInfoDialogAlert">Show Info Alert</v-btn>
              </v-col>
              <v-col>
                <v-btn width="100%" @click="onShowWarningDialogAlert">Show Warning Alert</v-btn>
              </v-col>
              <v-col>
                <v-btn width="100%" @click="onClearAlert">Clear Alert</v-btn>
              </v-col>
            </v-row>
          </v-list-item>
          <v-divider></v-divider>
          <v-row>
            <p>
              {{ testText }}
            </p>
          </v-row>
        </template>
      </cs-dialog>
      <cs-dialog
        v-model="textTitleDialog"
        transition="dialog-bottom-transition"
        scrollable
        max-width="700px"
      >
        <template v-slot:dialog-title>
          <span>Dialog Title</span>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="textTitleDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </template>
        <template v-slot:dialog-body-text>
          <p>This is dialog title, uses v-card-title.</p>
          <p>{{ testText }}</p>
        </template>
        <v-spacer></v-spacer>
        <template v-slot:dialog-actions>
          <v-btn @click="onShowErrorDialogAlert">Show Error Alert</v-btn>
          <v-btn @click="onShowSuccessDialogAlert">Show Success Alert</v-btn>
          <v-btn color="green darken-1" text @click="textTitleDialog = false"> Disagree </v-btn>
          <v-btn color="green darken-1" text @click="onAgree"> Agree </v-btn>
        </template>
      </cs-dialog>
      <cs-dialog
        v-model="headerDialog"
        transition="dialog-bottom-transition"
        scrollable
        max-width="800px"
      >
        <template v-slot:dialog-header>
          <span>Dialog Header</span>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="headerDialog = false" color="white">
            <v-icon>close</v-icon>
          </v-btn>
        </template>
        <template v-slot:dialog-body-text>
          <p>This is dialog header, uses v-toolbar as header.</p>
          <p>{{ testText }}</p>
        </template>
        <v-spacer></v-spacer>
        <template v-slot:dialog-actions>
          <v-btn @click="onShowErrorDialogAlert">Show Error Alert</v-btn>
          <v-btn @click="onShowSuccessDialogAlert">Show Success Alert</v-btn>
          <v-btn color="green darken-1" text @click="headerDialog = false"> Disagree </v-btn>
          <v-btn color="green darken-1" text @click="onAgree"> Agree </v-btn>
        </template>
      </cs-dialog>
    </template>
  </cs-view>
</template>

<script>
import jwt from 'jsonwebtoken';
import { CSBase } from '@complispace/cs-design-system';
import { mapGetters, mapMutations } from 'vuex';
import SlotIndicator from '../components/SlotIndicator';
import ExportDocx from '../components/ExportDocx';
import * as types from '../store/mutationTypes';
import FormDialogsTest from '../components/FormDialogsTest';

export default {
  name: 'Home',

  components: {
    SlotIndicator,
    ExportDocx,
    'form-dialogs-test': FormDialogsTest
  },

  extends: CSBase,

  data() {
    return {
      geminiUrl: process.env.VUE_APP_GEMINI_URL,
      apolloUrl: process.env.VUE_APP_APOLLO_URL,
      artemisUrl: process.env.VUE_APP_ARTEMIS_URL,
      fullscreenDialog: false,
      textTitleDialog: false,
      headerDialog: false,
      warningText: 'Are you sure you want to delete this page?\nThis action cannot be undone.',
      lockText: 'Your session has exceeded... hrs.\nPlease click continue to secure your session.',
      checkbox1: false,
      checkbox2: false,
      checkbox3: true,
      tokenText: '',
      decodedTokenText: '',
      userText: '',
      tokenLoading: false,
      userLoading: false,
      logoutLoading: false,
      testText:
        'This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. This is a really long list. ',
      selectedImg: {},
      items: [],
      primaryAction: { label: 'Delete', eventName: 'warning-dlg-delete', disabled: true },
      secondaryAction: { label: 'Cancel', eventName: 'warning-dlg-cancel', disabled: false }
    };
  },

  async mounted() {
    this.setPageViewType('single-view');
  },

  methods: {
    ...mapMutations({
      setPageViewType: types.VIEW_TYPE_SET_PAGE_VIEW_TYPE
    }),

    onSetLoading() {
      this.setLoading(true);
    },

    onClearLoading() {
      this.clearLoading();
    },

    onShowErrorAlert() {
      this.showErrorAlert(
        'This is an error alert.This is an error alert.This is an error alert.This is an error alert.This is an error alert.This is an error alert.This is an error alert.This is an error alert.This is an error alert.This is an error alert.This is an error alert.This is an error alert. This is an error alert.This is an error alert.This is an error alert.This is an error alert.This is an error alert.This is an error alert.This is an error alert.This is an error alert.This is an error alert.This is an error alert.This is an error alert.This is an error alert. This is an error alert.This is an error alert.This is an error alert.This is an error alert.This is an error alert.This is an error alert.This is an error alert.This is an error alert.This is an error alert.This is an error alert.This is an error alert.This is an error alert.'
      );
    },

    onShowErrorAlertWithHrefAndFunc() {
      const options = {
        href: 'https://complispace.zendesk.com/hc/en-us/requests/new',
        func: () => {
          // eslint-disable-next-line no-alert
          alert('clickable alert function executed');
        }
      };
      this.showErrorAlert(
        'This is a clickable error alert. Click <href>here</href> to be redirected to any defined URL. Click <func>here</func> to execute any function.',
        false,
        options
      );
    },

    onShowSuccessAlert() {
      this.showSuccessAlert('This is an success alert.');
    },

    onShowSuccessAlertWithHref() {
      const options = {
        href: 'https://complispace.zendesk.com/hc/en-us/requests/new'
      };
      this.showSuccessAlert(
        'This is a clickable success alert. Click <href>here</href> to be redirected to any defined URL.',
        false,
        options
      );
    },

    onShowInfoAlert() {
      this.showInfoAlert('This is an info alert.');
    },

    onShowInfoAlertWithFunc() {
      const options = {
        func: () => {
          // eslint-disable-next-line no-alert
          alert('clickable alert function executed');
        }
      };
      this.showInfoAlert(
        'This is a clickable success alert. Click <func>here</func> to execute any function.',
        false,
        options
      );
    },

    onShowWarningAlert() {
      this.showWarningAlert('This is an warning alert.');
    },

    onShowWarningAlertWithHrefAndFunc() {
      const options = {
        href: 'https://complispace.zendesk.com/hc/en-us/requests/new',
        func: () => {
          // eslint-disable-next-line no-alert
          alert('clickable alert function executed');
        }
      };
      this.showWarningAlert(
        'This is a clickable warning alert. Click <href>here</href> to be redirected to any defined URL. Click <func>here</func> to execute any function.',
        false,
        options
      );
    },

    onShowErrorDialogAlert() {
      this.showErrorAlert('This is an error alert.', true);
    },

    onShowSuccessDialogAlert() {
      this.showSuccessAlert('This is an success alert.', true);
    },

    onShowInfoDialogAlert() {
      this.showInfoAlert('This is an info alert.', true);
    },

    onShowWarningDialogAlert() {
      this.showWarningAlert('This is an warning alert.', true);
    },

    onClearAlert() {
      this.clearAlert();
    },

    onAgree() {
      this.textTitleDialog = false;
      this.headerDialog = false;
      this.showSuccessAlert('Agreed');
    },

    async onGetToken() {
      this.tokenLoading = true;
      this.tokenText = '';
      this.decodedTokenText = '';

      this.tokenText = await this.$store.dispatch('cs-session/getToken');
      const decoded = jwt.decode(this.tokenText, { complete: true });
      this.decodedTokenText = JSON.stringify(decoded, undefined, 2);
      this.tokenLoading = false;
    },

    async onGetUser() {
      this.userLoading = true;
      this.userText = '';
      const auth = await this.$store.dispatch('auth0/buildClient');
      const user = await auth.getUser();
      this.userText = JSON.stringify(user, undefined, 2);
      this.userLoading = false;
    },

    async onLogout() {
      this.logoutLoading = true;
      await this.$store.dispatch('cs-session/logout', { federated: true });
      this.logoutLoading = false;
    },

    copyText() {
      const tokenText = document.querySelector('#token-text');
      tokenText.setAttribute('type', 'text');
      tokenText.select();
      try {
        document.execCommand('copy');
        tokenText.style.display = 'none';
        this.showSuccessAlert('Token Copied !!');
      } catch (error) {
        this.showErrorAlert(error.message);
      }
    }
  },

  computed: {
    ...mapGetters({
      user: 'cs-session/user',
      engineeringMode: 'engineering/enabled'
    })
  }
};
</script>

<style scoped>
.code {
  text-align: left;
}

.token {
  text-align: left;
}

.icon-btn {
  margin-bottom: 10px;
  cursor: pointer;
}
</style>
